import utils from "Sources/utils/utils";
import NavUtils from "Sources/utils/navigation-utils";
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/history-bar/history-bar.html";

import "Styles/components/history-bar.scss";

class HistoryBar
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.historyObject = options.historyObject;
  }

  get historyObject()
  {
    return this._historyObject;
  }

  set historyObject(historyObject)
  {
    this._historyObject = historyObject;
    this.updateHistoryBar();
  }

  static setUpHistoryBar(options)
  {
    let instance = new HistoryBar(options);
    instance.render();
    return instance;
  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);
    this.updateHistoryBar();
    LanguageManager.applyLocale(this.$element);
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }


  updateHistoryBar()
  {
    if(utils.isNotNull(this.$element))
    {
      this.historyObject.forEach(page => {
        let element = $("<a class='small-grey-text' href='" + page.location + "'><span>\t&gt;</span><span data-localize='" + page.name + "'></span></a>");
        this.$element.append(element);
      });

    }
  }
}

export default HistoryBar;



// WEBPACK FOOTER //
// ./app/js/components/history-bar.js